import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios'

Vue.use(Vuex);

// export default new Vuex.Store({
//   state: {},
//   getters: {},
//   mutations: {},
//   actions: {},
//   modules: {},
// });


export default new Vuex.Store({
	state: sessionStorage.getItem("state")?JSON.parse(sessionStorage.getItem("state")): {
		//‘状态’集合 类似 vue‘data’  ‘状态’内数值的更改只能通过 ‘提交’ mutation来改变
		token: localStorage.getItem("token"),
		password: localStorage.getItem("password"),
		detailMenuIndex: localStorage.getItem("detailMenuIndex"),
		baseInfo: JSON.parse(sessionStorage.getItem("baseInfo")),
		userList:[],//用户列表
		menulistdisorder:[],//菜单列表（未整理）//值的格式 {"id":"8","name":"监狱可视化","parentId":"","index":"0","path":{"name":"visuallargescreen"}}
		menulist: [],//菜单列表（已整理）
		taglist:[],//标签列表
		dynamicNewsList:[],//新闻动态列表
		roleList:[],//角色列表
		userSexList:[],//性别列表
	},
	getters: {
		//计算属性 可state作为第一个参数，getters做为第二个参数
		getUser: state => {
			return state.baseInfo
		},
	},
	mutations: {
		clear(state){//清空state
			for (let i in state) {
				delete state[i];
			}
		},
		SET_TOKEN: (state, token) => {
			state.token = token
			localStorage.setItem("token", token)
		},
		SET_PASSWORD:(state,password)=>{
			state.password = password
			localStorage.setItem("password",password)
		},
		SET_DETAILMENUINDEX:(state,detailMenuIndex)=>{
			state.detailMenuIndex = detailMenuIndex
			localStorage.setItem("detailMenuIndex",detailMenuIndex)
		},
		SET_BASEINFO: (state, baseInfo) => {
			state.baseInfo = baseInfo
			sessionStorage.setItem("baseInfo", JSON.stringify(baseInfo))
		},
		//----------
		REMOVE_INFO: (state) => {
			state.token = ''
			state.baseInfo = {}
			sessionStorage.setItem("token", '')
			sessionStorage.setItem("baseInfo", JSON.stringify(''))
		},
		setuserList(state,data){
			state.userList=data;
		},
		setmenulistdisorder(state,data){//菜单列表（未整理）
			state.menulistdisorder=data;
		},
		setmenulist(state,data){//菜单列表（已整理）
			state.menulist=data;
		},
		settaglist(state,data){
			state.taglist=data;
		},
		//payload:{index,num}
		splicetaglist(state,payload){//taglist的splice方法
			state.taglist.splice(payload.index,payload.num);
		},
		pushtaglist(state,arr){//taglist的push方法
			state.taglist.push(arr);
		},
		setnewsTypeList(state,data){//消息类型
			state.newsTypeList=data;
		},
		setDynamicNewsList(state,data){//新闻动态列表
			state.dynamicNewsList = data;
		},
		setroleList(state,data){//角色列表
			state.roleList=data;
		},
		setuserSexList(state,data){//性别列表
			state.userSexList=data;
		},
	},
	actions: {
		setnewsTypeList(context){//消息类型
			var formData=new FormData();
			formData.append('parentcode',"newsType");
			axios.post('/web/baseDict/searchDict',formData)
			.then((response)=>{
				var data=response.data.data;
				context.commit("setnewsTypeList",data);//调用mutation提交数据
			})
			.catch((error)=>{
					console.log(error);
			});
		},
		setroleList(context){//角色列表
			axios.post('/web/roleinfo/roles')
			.then((response)=>{
				var data=response.data.data;
				context.commit("setroleList",data);//调用mutation提交数据
			})
			.catch((error)=>{
					console.log(error);
			});
		},
		setuserSexList(context){//性别列表
			var formData=new FormData();
			formData.append('parentcode',"gender");
			axios.post('/web/baseDict/searchDict',formData)
			.then((response)=>{
				var data=response.data.data;
				context.commit("setuserSexList",data);//调用mutation提交数据
			})
			.catch((error)=>{
					console.log(error);
			});
		},
	},
	modules: {
	}
});
